import { useCallback, useMemo, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import SelectPublico from "../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import { permitirApenasNumeros } from "../../../../../../helpers/masks";
import SelectVendedores from "../../../../../../components/SelectsSimpleApiQuery/SelectVendedores";
import { TFilterState } from "../Listagem";
import DateComIntervalo from "../../../../../../components/DateComIntervalo";

export function FiltroModal({
    open,
    dialogFilters,
    handleClose,
    handleFilterSubmit,
    onClearFilters
}: FilterModal) {

    const situacoes = useMemo(() => [
        'Aprovação',
        'Cancelado',
        'Pagamento',
        'Expedição',
        'Finalizado',
        'Todas'
    ], []);


    const [filters, setFilters] = useState<TFilterState>(dialogFilters);

    //funções manipuladoras
    const handleChangeFilters = (
        prop: keyof any,
        value: any
    ) => {
        let valorProp = value
        if (prop === "situacoes") valorProp = verificacaoTodosArray(value as string[])

        setFilters((prevState: any) => ({
            ...prevState,
            [prop]: valorProp,
        }));

    };

    const verificacaoTodosArray = (arr: string[]): string[] => {
        const ultimoItem = arr[arr.length - 1]?.toLowerCase() === "todas";

        if (ultimoItem) return ['Todas'];
        if (!ultimoItem) return arr.filter(item => item.toLowerCase() !== "todas")
        return arr;
    }

    const handleApply = useCallback(() => {
        const updatedFilters = { ...filters };
        if (updatedFilters.situacoes.includes('Todas')) {
            updatedFilters.situacoes = [];
        }

        handleFilterSubmit(updatedFilters);
        handleClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])
    //

    return (
        <>
            <Dialog
                id="draggable-dialog-title"
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle sx={{ cursor: "move" }}>Filtros</DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ py: 2 }}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <SelectPublico
                                value={filters.publico_dado}
                                onChange={(valor) => handleChangeFilters("publico_dado", valor)}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Código do pedido"
                                variant="outlined"
                                fullWidth
                                value={filters.codigo_pesquisar}
                                onChange={(e) => {
                                    handleChangeFilters("codigo_pesquisar", permitirApenasNumeros(e.target.value))
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Comprador"
                                variant="outlined"
                                fullWidth
                                value={filters.comprador_pesquisar}
                                onChange={(e) => {
                                    handleChangeFilters("comprador_pesquisar", e.target.value)
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <SelectVendedores
                                value={filters.vendedor_dado}
                                onChange={(e) => {
                                    handleChangeFilters("vendedor_dado", e)
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Condição de pagamento"
                                variant="outlined"
                                fullWidth
                                value={filters.condicao_pagamento_id_pesquisar}
                                onChange={(e) => {
                                    handleChangeFilters("condicao_pagamento_id_pesquisar", e.target.value)
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <FormControl fullWidth>
                                <InputLabel id="situacoes-label">Situação</InputLabel>
                                <Select
                                    labelId="situacoes-label"
                                    label="Situação"
                                    multiple
                                    value={filters.situacoes}
                                    onChange={(e) => handleChangeFilters("situacoes", e.target.value)}
                                    renderValue={(selected) => (selected as string[]).join(', ')}
                                >
                                    {situacoes.map((situacao) => (
                                        <MenuItem key={situacao} value={situacao}>{situacao}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="NF de Expedição"
                                variant="outlined"
                                fullWidth
                                value={filters.nf_expedicao_numero}
                                onChange={(e) => {
                                    handleChangeFilters("nf_expedicao_numero", permitirApenasNumeros(e.target.value))
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <DateComIntervalo
                                data={filters.data_emissao}
                                onChangeData={(obj) => handleChangeFilters("data_emissao", obj)}
                                datePickerView={["year", "month", "day"]}
                                formatString="DD/MM/YYYY"
                                labelInput="Data de Emissão"
                                possuiBtnLimpar={false}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            onClearFilters();
                            handleClose();
                        }}
                    >
                        Limpar
                    </Button>

                    <Button
                        autoFocus
                        variant="contained"
                        onClick={handleApply}
                    >
                        Filtrar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

interface FilterModal {
    open: boolean;
    dialogFilters: any;
    handleClose: () => void;
    handleFilterSubmit: (form: any) => void;
    onClearFilters: () => void;
}
